import React from "react";
import ReportStatCard from "./ReportStatCard";

const ProfitLossCards = ({ data }) => {
  return (
    <>
      <ReportStatCard
        title="Revenue (Ex-GST)"
        value={`₹${data.revenue.toLocaleString("en-IN")}`}
        subtitle="Net revenue before GST"
      />

      <ReportStatCard
        title="Material & Making Cost"
        value={`₹${data.materialMakingCost.toLocaleString("en-IN")}`}
        subtitle="Product cost"
      />

      <ReportStatCard
        title="Courier Cost"
        value={`₹${data.courierCost.toLocaleString("en-IN")}`}
        subtitle="Shipping expense"
      />

      <ReportStatCard
        title="Gateway Fees"
        value={`₹${data.gatewayFees.toLocaleString("en-IN")}`}
        subtitle="Payment processing"
      />

      <ReportStatCard
        title="Discounts & Coupons"
        value={`₹${data.discountsCoupons.toLocaleString("en-IN")}`}
        subtitle="Discount given"
      />

      <ReportStatCard
        title="Refunds"
        value={`₹${data.refunds.toLocaleString("en-IN")}`}
        subtitle="Refund expense"
      />

      <ReportStatCard
        title="Net Profit"
        value={`₹${data.netProfit.toLocaleString("en-IN")}`}
        subtitle="Final profit"
      />

      <ReportStatCard
        title="Profit Margin"
        value={`${data.margin}%`}
        subtitle="Net profit margin"
      />
    </>
  );
};

export default ProfitLossCards;
